import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import PendingSupplierOrders from "./PendingSupplierOrders";
import ManutentionsAConfirmer from "./ManutentionsAConfirmer";
import ManutentionsLivreurs from "./ManutentionsLivreurs";
import LiveursLocations from "./LiveursLocations";
import LivreursAlerts from "./LivreursAlerts";
import ClientsEnLigne from "./ClientsEnLigne";
import ObjectifMois from "./ObjectifMois";
import LivraisonsJours from "./LivraisonsJours";

// Définition du composant fonctionnel
function Dashboard() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Récupération des données de l'utilisateur depuis le stockage local
    const userData = JSON.parse(localStorage.getItem("userData"));

    // Définir les données de l'utilisateur dans l'état
    if (userData) {
      setUser(userData);
    }
  }, []);
  // Rendu du composant
  return (
    <Container>
      <p className="h1 pb-4 pt-4">
        Bonjour {user ? `${user.prenom} ${user.nom}` : "Administrateur"}
      </p>

      {/* Ou en est le mois — tout en haut, et avant les clients en ligne.
          C'est la seule information de cet ecran qui porte sur une DUREE :
          elle ne se perime pas en quelques minutes, mais elle oriente la
          journee entiere. Le reste du dashboard dit quoi faire maintenant ;
          celle-ci dit s'il faut pousser. */}
      {/* Aujourd'hui et demain, au-dessus du mois : ce qui se joue dans la
          journée se lit avant ce qui s'accumule sur le mois. */}
      <div style={{ paddingTop: "10px" }}>
        <LivraisonsJours />
      </div>

      <div style={{ paddingTop: "20px" }}>
        <ObjectifMois />
      </div>

      {/* Section Clients — la premiere des informations du MOMENT, et la seule
          qui perime en quelques minutes. Un client present maintenant peut
          etre appele maintenant ; dans une heure, l'information ne vaut plus
          rien. Seule la jauge du mois passe avant, parce qu'elle ne se perime
          pas et qu'elle oriente tout le reste. */}
      <div style={{ paddingTop: "20px" }}>
        <h2 className="h3 pb-3" style={{ borderBottom: "2px solid #dee2e6" }}>
          Clients
        </h2>
        <div style={{ paddingTop: "20px" }}>
          <ClientsEnLigne />
        </div>
      </div>

      {/* Section Commandes */}
      <div style={{ paddingTop: "20px" }}>
        <h2 className="h3 pb-3" style={{ borderBottom: "2px solid #dee2e6" }}>
          Commandes
        </h2>
        {/* Placé avant les commandes en cours : c'est la seule information du
            dashboard dont l'inaction coûte de l'argent de façon définitive.
            Le composant ne rend rien quand il n'y a rien à confirmer. */}
        <div style={{ paddingTop: "20px" }}>
          <ManutentionsAConfirmer />
        </div>
        {/* Les saisies des livreurs, juste après : elles s'appliquent
            directement au montant facturé et sortent la commande du carton
            ci-dessus, donc sans cet écran elles seraient invisibles. */}
        <div style={{ paddingTop: "20px" }}>
          <ManutentionsLivreurs />
        </div>
        <div style={{ paddingTop: "20px" }}>
          <PendingSupplierOrders />
        </div>
      </div>

      {/* Section Livreurs */}
      <div style={{ paddingTop: "40px" }}>
        <h2 className="h3 pb-3" style={{ borderBottom: "2px solid #dee2e6" }}>
          Livreurs
        </h2>
        <div style={{ paddingTop: "20px" }}>
          <LivreursAlerts />
        </div>
        <div style={{ paddingTop: "20px" }}>
          <LiveursLocations />
        </div>
      </div>
    </Container>
  );
}
// Exportation du composant par défaut
export default Dashboard;
